import React from 'react'
import FormularioBlog from './FormularioBlog'

const NuevoBlog = () => {
  return (

    <>
    <div>
        <h1 className='text-4xl text-center'>Nuevo Blog</h1>
    </div>
    <div>
        <FormularioBlog/>
    </div>
    </>
  )
}

export default NuevoBlog